<template>
  <div>
    <div style="display: flex;gap: 10px">
      <el-select v-model="searchVal" placeholder="请选择">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-input v-model="val" style="width: 40%;"></el-input>
      <el-button type='primary' @click="searchData">搜索</el-button>
      <el-button type='primary' @click="submitData">提交</el-button>
    </div>
    <!-- v-loading="tableloading" -->
    <div style="margin-top: 5px;">
      <vxe-grid ref="xGrid" v-bind="addTableList" @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent">
        <template #quantityEdit="{ row }">
          <vxe-input v-model="row.quantity"></vxe-input>
        </template>
        <template #orderEdit="{ row }">
          <vxe-input v-model="row.order"></vxe-input>
        </template>
        <!-- <template v-slot:toolbar>
          <vxe-toolbar custom>
            <template v-slot:buttons> </template>
          </vxe-toolbar>
        </template> -->
      </vxe-grid>
    </div>

    <el-pagination class="pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :page-sizes="pageSizes" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      val: '',
      options: [],
      searchVal: '',

      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,
      totalRecords: 0,
      paginationShow: false,

      loading: false,
      rowStyle: { cursor: "pointer" },
      tableToolbar: {
        // buttons: [{ code: "myInsert", name: "", type: "text" }],

        // custom: true,
        slots: {
          tools: "tools",
        },
      },

      addTableList: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "530",
        size: "small",
        columns: [],
        data: [],

        editConfig: {
          trigger: "dblclick",
          mode: "cell",
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: "cell",
        },
        // checkboxConfig:{
        //   labelField: 'name',
        //   checkMethod: this.checkboxMethod}
      },
      validRules: {
        quantity: [
          { required: true, }
        ],

      },

    }
  },
  props: ['majorInfo'],
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchClick();

    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchClick();
      // const { data: res } = await this.$http.get(loadTableUrl);
    },

    submitData() {

      const rows = this.$refs.xGrid.getCheckboxRecords();
      const data = this.getMajorData();
      const obj = { rows, data };
      // return
      this.$emit('setAlteData', obj)

    },
    getMajorData() {
      const { row, col } = this.majorInfo;
      console.log(row, col);

      const obj = {};
      col.forEach((i, e) => {
        if (i?.attid == 1003002) {
          obj[i['attid']] = row[e]
        }
      })
      return obj
    },

    selectAllEvent({ checked, row }) {
      // const records = this.$refs.xTable1.getCheckboxRecords()
      const records = this.$refs.xGrid.getCheckboxRecords();
      // console.log(checked ? '所有勾选事件' : '所有取消事件', records)
      if (checked) {
        records.map(i => {
          if (!i.quantity) {
            i.quantity = '1'
          }
        })
      }
    },
    selectChangeEvent({ checked, row }) {
      // const records = this.$refs.xTable1.getCheckboxRecords()
      // console.log(checked ? '勾选事件' : '取消事件', records)
      console.log(checked, row);
      if (checked && !row.quantity) {
        row.quantity = '1'
      }
    },
    searchData() {
      const obj = {
        value: this.val,
        subClassId: this.searchVal,
        page: 1,
        size: 100
      };
      axios.get('pmdm/items/simpleSearchBySubCalss', { params: obj }).then(
        res => {
          console.log(res);
          const { columnInfo, rows } = res.data.object;
          const columnList = columnInfo.names.map((i, e) => {
            const field = columnInfo.columns[e].replaceAll('.', '-')
            const obj = { title: i, field };
            return obj

          });

          const data = rows.map(i => {
            const { cells, objId: id, objClass: classId, objSubClass: subClassId } = i
            const obj = {
              objInfo: { id, classId, subClassId }
            };
            columnList.forEach((item, e) => {
              obj[item['field']] = cells[e]['val'];
            })

            return obj
          })
          columnList.splice(2, 0,
            { field: 'quantity', title: '数量', editRender: { name: "$input", attrs: { type: "text" } }, slots: { edit: 'quantityEdit' } },
            { field: 'order', title: '替代顺序', editRender: { name: "$input", attrs: { type: "text" } }, slots: { edit: 'orderEdit' } },
          )
          this.addTableList.columns = [{ type: "checkbox", width: 50 }, ...columnList]
          this.addTableList.data = data

        }
      )
    },
    getData() {
      const { row } = this.majorInfo
      axios.get('/pmdm/admin/cls/getSubClses?clsId=' + row.itemClassId).then(res => {
        this.options = res.data.object.subClses.map(i => ({
          value: i.id,
          label: i.name
        }))
        this.searchVal = row.itemSubClassId
      })
    }
  },
  created() {
    console.log(this.majorInfo);
    this.getData();

  },
}
</script>

<style scoped></style>